mobileSize = 1079;

function ticketsButtons() {
  if ($('body').hasClass('saffireMobileSize')) {
    $(".header-top-right .tix-bx").appendTo(".header .header-bottom-inner");
  } else {
     $('.header .header-bottom-inner .tix-bx').appendTo('.header-top-right');
  }
}


$(document).ready(function(){  
  $(".event-container-main .subscribe-main .emailInputSubmit .emailSubmitButton").text("Subscribe");
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1080) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1079) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
  
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');  
 // $(".header .searchBoxInput input").attr("placeholder", "Search Website");
  $(".subscribe-main.white-bx .emailSignup .emailInputField input").attr("placeholder", "Email Address");  
  $(".event-container-main .subscribe-main .emailInputSubmit .emailSubmitButton").text("Subscribe");
  $(".featureLineup-text").text(function(){
    return $(this).text().length > 120 ? $(this).text().substr(0, 120)+'...' : $(this).text();
  });

  ticketsButtons()
});

$(window).resize(function() {
  ticketsButtons() 
});